import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

export interface ManagerProfile {
  userId: number;
  email: string;
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string | null;
  ico: string | null;
  billingStatus: string | null;
}

export interface UpdateManagerProfileRequest {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  ico: string;
}

export interface ChangeManagerPasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export const getMyProfile = async (token: string): Promise<ManagerProfile> => {
  const res = await axios.get(`${API_BASE}/managers/me`, {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
  return res.data;
};

export const updateMyProfile = async (
  payload: UpdateManagerProfileRequest,
  token: string
): Promise<ManagerProfile> => {
  const res = await axios.put(`${API_BASE}/managers/me`, payload, {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
  return res.data;
};

export const changeMyPassword = async (
  payload: ChangeManagerPasswordRequest,
  token: string
): Promise<{ success: boolean; message: string }> => {
  const res = await axios.put(`${API_BASE}/managers/me/password`, payload, {
    headers: { Authorization: `Bearer ${token}` },
    withCredentials: true,
  });
  return res.data;
};

